import axios from 'axios'
import qs from 'qs'

import store from '@/store/global-store'

import {routesObj} from '@/routes/index'
import { provinces_offline_jobs, provinces_city_offline_jobs } from "@/datas/area.js";

var tmpTag = 'https:' === document.location.protocol ? false : true
var hostname = document.location.hostname
if (tmpTag && hostname !== 'localhost' && hostname != 'test.kuaizp.cn') {
  var urls = window.location.href
  urls = urls.replace('http', 'https')
  window.location = urls
}

let util = {}

util.version = '1.1.0209.01'
util.title = function (title) {
  title = title || '云校招'
  window.document.title = title
}

// 平台、设备和操作系统 ，返回ture或false,true表示是移动端，false表示不是移动端
util.ismobile = function () {
  var mobileArry = ['iPhone', 'iPad', 'Android', 'Windows Phone', 'BB10; Touch', 'BB10; Touch', 'PlayBook', 'Nokia']
  var ua = navigator.userAgent
  var res = mobileArry.filter(function (arr) {
    return ua.indexOf(arr) > 0
  })
  return res.length > 0
}

util.ajaxUrl = process.env.AJAX_URL

var picUrl = 'https://o.bysjy.com.cn/'
var picPath = 'http://pic.bibibi.net/'
var aliPath = 'http://yun-campus-res.oss-cn-shenzhen.aliyuncs.com/'
var aliPathHttps = 'https://yun-campus-res.oss-cn-shenzhen.aliyuncs.com/'

util.error_seeker_logo = 'https://o.bysjy.com.cn/kzp/public/photo_default.png'
util.error_company_logo = 'https://o.bysjy.com.cn/company/98762/1564037265-8660.png'
util.error_img_sm = 'https://o.bysjy.com.cn/kzp/public/none-pic.png'
// 视频双选会默认图片
util.error_img_jobfair = 'https://o.bysjy.com.cn/kzp/template/1611829668-7803.jpg?'
// 云宣讲默认图片
util.error_img_career_talk = 'https://o.bysjy.com.cn/kzp/template/1611829691-1169.jpg'
// 近日招聘
util.error_img_online_career = 'https://o.bysjy.com.cn/kzp/template/1611829706-8254.jpg'

util.error_img_obj = {
  video_fair: util.error_img_jobfair, 
  online_career: util.error_img_online_career, 
  career_talk: util.error_img_career_talk
}
util.newVersionTime = 1647878400;

util.ajax = axios.create({
  baseURL: util.ajaxUrl,
  timeout: 60000,
  withCredentials: true // 表示跨域请求时是否需要使用凭证”。这个“凭证”是在withCredentials开启时自动生成并保存在cookie中然后在http请求的时候带上
})

var cookie = {
  setCookie: function (name, value, date) {
    var d = new Date()
    d.setTime(d.getTime() + date)
    document.cookie = name + '=' + value + ';expires=' + d

    console.log('document.cookie', document.cookie)
  },
  getCookie: function (name) {
    var arr = document.cookie.split('; ')
    console.log('cookie', arr)

    for (var i = 0; i < arr.length; i++) {
      var arr2 = arr[i].split('=')
      if (arr2[0] == name) {
        return arr2[1]
      }
    }
    return ''
  },
  removeCookie: function (name) {
    cookie.setCookie(name, '', -1)
  }

}

var _sign_keys = 'kzp_user_sign'
var _province_key = 'kzp_province_key'
util.setSign = function (sign) {
  // return cookie.setCookie(_sign_keys, encodeURIComponent(sign || ''), 100000);
  return localStorage.setItem(_sign_keys, sign || '')
}

util.getSign = function () {
  // return decodeURIComponent(cookie.getCookie(_sign_keys) || '');
  return localStorage.getItem(_sign_keys) || ''
}

util.clearSession = function () {
  // localStorage.clear();
  // cookie.removeCookie(_sign_keys, '')
  localStorage.removeItem(_sign_keys)
}

util.format_url = function (url) {
  return url += (url.indexOf('?') > 0 ? '&' : '?') + '&token=kzp_web_pc_2020&sign=' + util.getSign()
}

util.post = function (control, action, params) {
  var url = control.indexOf('http') >= 0 || control.indexOf('index.php?r=') >= 0 ? control : 'index.php?r=' + control + '/ajax_' + action
  return new Promise((resolve) => {
    util.ajax.post(util.format_url(url), qs.stringify(params)).then((response) => {
      const {data} = response
      var msg = data.msg
      var code = data.code
      if (!(params && params.silence)) {
        // 如果提示为需要登录，则拦截信息
        util.errorFn(msg)

        if (code !== 1 && typeof msg === 'string' && msg.indexOf('请登录') >= 0) {
          return resolve({code: -1, msg: ''})
          // return
          // reject();
        }
      }

      resolve(data)
    }, function (error) {
      const {response, message} = error || {}
      return resolve({code: -1, url: url, msg: message || '发送请求失败'})
      // const { response } = error
      // if (!response) return
      // if ([401].indexOf(response.status) >= 0) {

      // }
      // if (response.hasOwnProperty('data')) {
      //     return Promise.reject(response.data)
      // } else {
      //     return Promise.reject(response)
      // }
    })
  })
}

util.get = function (control, action, params) {
  var url = control.indexOf('http') >= 0 || control.indexOf('index.php?r=') >= 0 ? control : 'index.php?r=' + control + '/ajax_' + action
  return new Promise((resolve, reject) => {
    util.ajax.get(util.format_url(url), {
      params: params
    }).then((response) => {
      const {data} = response
      var msg = data.msg
      var code = data.code
      if (!(params && params.silence)) {
        // 如果提示为需要登录，则拦截信息
        util.errorFn(msg)

        if (code !== 1 && typeof msg === 'string' && msg.indexOf('请登录') >= 0) {
          return resolve({code: -1, msg: ''})
          // return
          // reject();
        }
      }

      resolve(data)
    }, function (error) {
      const {response, message} = error || {}
      return resolve({code: -1, url: url, msg: message || '发送请求失败'})
      // if (!response) return resolve({ code: -1, url: url, msg: message })
      // if ([401].indexOf(response.status) >= 0) {

      // }
      // if (response.hasOwnProperty('data')) {
      //     return Promise.reject(response.data)
      // } else {
      //     return Promise.reject(response)
      // }
    })
  })
}

// 检查求职者是否登录
util.checkLogin = function (params) {
  // 检查登录状态
  var user = store.state.user
  if (user && user.mobile) {
    return true
  }

  // 是否弹出登录窗口; 默认true
  if (params && params.is_login_modal != false) {
    return false
  } else {
    util.errorFn('请登录')
  }

  return false
}

util.errorFn = function (msg) {
  if (typeof msg === 'string' && msg.indexOf('请登录') >= 0) {
    // clear用户信息
    util.clearSession()

    // 弹出登录框
    store.commit('changeLoginState', [
      {
        key: 'is_show_dialog',
        value: true
      },
      {
        key: 'is_show_bind_mobile',
        value: false
      }
    ])
    store.commit('changeUser', {data: {}})
  }
}

util.getQueryString = function (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return ''
}

util.isArrayFn = function (value) {
  if (typeof Array.isArray === 'function') {
    return Array.isArray(value)
  } else {
    return Object.prototype.toString.call(value) === '[object Array]'
  }
}

var getValue = function (obj, cols, params) {
  if (Object.prototype.toString.call(obj) === '[object Object]') {
    var url = '';
    (function getKeysFn (o, _index) {
      if (cols[_index]) {
        var key = cols[_index]
        if (Object.prototype.toString.call(o[key]) === '[object Object]') {
          getKeysFn(o[key], _index + 1)
        } else {
          url = o[key]
          if (!url || url.indexOf('http') < 0) {
            url = params.default_img || util.error_seeker_logo
          } else if (url.indexOf('https') < 0) {
            url = url.replace(aliPath, picUrl).replace(picPath, picUrl)
          } else {
            url = url.replace(aliPathHttps, picUrl)
          }

          if (url.indexOf('x-oss-process') < 0) {
            if (params.style) {
              url += ('?x-oss-process=style/' + params.style)
            } else if (params.resize) {
              url += ('?x-oss-process=image/resize,m_fill,' + params.resize)
            }
          }
          o[key] = url
        }
      }
    })(obj, 0)
  } else if (Object.prototype.toString.call(obj) === '[object String]') {
    let o = obj
    if (!o || o.indexOf('http') < 0) {
      o = params.default_img || util.error_seeker_logo
    } else if (o.indexOf('https') < 0) {
      o = o.replace(aliPath, picUrl).replace(picPath, picUrl)
    } else {
      o = o.replace(aliPathHttps, picUrl)
    }
    if (o.indexOf('x-oss-process') < 0) {
      if (params.style) {
        o += ('?x-oss-process=style/' + params.style)
      } else if (params.resize) {
        o += ('?x-oss-process=image/resize,m_fill,' + params.resize)
      }
    } else {
      if (params.style) {
        o = replaceParamVal('x-oss-process', 'style/' + params.style, o)
      }
    }
    return o
  }
}

var replaceParamVal = function (paramName, replaceWith, str) {
  var oUrl = str || location.href.toString()
  var re = eval('/(' + paramName + '=)([^&]*)/gi')
  var nUrl = oUrl.replace(re, paramName + '=' + replaceWith)
  return nUrl
}

util.tansPics = function (array, col, params) {
  if (col) {
    if (!params) {
      var params = {}
    }
    let cols = col.indexOf('.') > -1 ? col.split('.') : [col]
    if (util.isArrayFn(array)) {
      for (let index = 0; index < array.length; index++) {
        getValue(array[index], cols, params)
      }
    } else {
      getValue(array, cols, params)
    }
  } else {
    return getValue(array, '', params)
  }
}

// 过滤富文本中的script / iframe标签 .js 字段
util.filterRichText = function (str) {
  if (typeof str !== 'string') {
    return ''
  }

  str = str.replace(
    /\<img/gi,
    '<img style="max-width:100%;height:auto" '
  )

  return str.replace(/\<script|\<iframe|\.js/gi, '')
}

util.routes = routesObj

// 页面跳转
util.page_explain = function (value, QueryString) {
  var item = routesObj[value]
  if (item && item.link) {
    var link = item.link

    link += link.indexOf('?') > 0 ? '&' : '?'
    if (util.isArrayFn(QueryString)) {
      QueryString.forEach(function (s) {
        link += s.name + '=' + (s.value || '') + '&'
      })
    } else if (QueryString && typeof QueryString === 'object') {
      for (var key in QueryString) {
        link += key + '=' + (QueryString[key] || '') + '&'
      }
    } else if (typeof QueryString === 'string') {
      link += QueryString
    }

    return link
  }
}

// 在页面之间跳转
util.pageto = function (value, QueryString) {
  var link = util.page_explain(value, QueryString)
  if (link) {
    location.href = link
  }
}

// 打开面试间页面
util.openVideo = function (tabs) {
  const w_height = parseInt(window.innerHeight)
  const w_width = parseInt(window.innerWidth)

  const default_h = 500,
    default_w = 1200

  const height =
      w_height * 0.8 > default_h ? parseInt(w_height * 0.8) : default_h,
    width = w_width * 0.8 > default_w ? parseInt(w_width * 0.8) : default_w

  const top = parseInt((w_height - height) / 2)
  const left = parseInt((w_width - width) / 2)

  // location=0,menubar=0,resizable=0,status=0,toolbar=0,
  window.open(
    '/seeker/video.html?tabs=' + (tabs || ''),
    'video',
    'left=' + left + ',top=' + top + ',width=' + width + ',height=' + height
  )
}

// 保存用户信息
util.saveInfo = function (user) {
  util.tansPics(user, 'user_header', {default_img: util.error_seeker_logo})
  // 用户当前登录有效
  store.commit('changeUser', {data: user})

  let keys = 'kzp_user_info'
  sessionStorage.setItem(keys, JSON.stringify(user))
}

// 获取用户信息
util.getInfo = function () {
  return new Promise((resolve) => {
    util.post('kzp_website', 'get_user_info', {silence: true})
      .then(function (res) {
        const {
          code, data
        } = res || {}
        const {
          user
        } = data || {}
        if (code === 1 && user) {
          util.saveInfo(user)
          resolve(true)
        } else {
          resolve(false)
        }
      }).catch(() => {
      resolve(false)
    })
  })
}

// 公共图片文件
util.imgConfig = {
  rocket: 'https://o.bysjy.com.cn/kzp/kzp_web/rocket.png'
}

// 站点设置
util.setProvinceConfig = function (item) {
  if (item) item = item.replace('站', '')
  return localStorage.setItem(_province_key, item === '全国' ? '' : item)
}

// 站点切换
util.getProvinceConfig = function () {
  return localStorage.getItem(_province_key) || ''
}

util.trim = function (str) {
  if (str) {
    str.replace(/(^\s*)|(\s*$)/g, '')
  } else {
    str = ''
  }
  return str
}

    /**
     * 处理职位大厅城市格式
     */
util.filterCity = function(showCitys){
      const demo = {
        provinces: provinces_offline_jobs,
        province_city: provinces_city_offline_jobs
      }

      if (!util.isArrayFn(showCitys)) {
        return demo;
      }

      let citys = [];
      const important_citys = ['北京', '上海', '天津', '重庆', '香港', '澳门'];
      let citys_obj = {};

      showCitys.forEach((items, index) => {
        if (typeof items.city == 'string') {
          // 空格隔开的城市
          const itemArr = items.city.split(' ')
          const province = items.province
          itemArr.forEach(element => {
            if (element) {
              // 去掉结尾的“市”字
              const slice_city = element.replace(/市$/, '');
              citys.push(slice_city)

              if (province && important_citys.includes(province) && !citys_obj[province]) {
                citys_obj[slice_city] = province;
              }
            }
          });
        }
      });

      if (citys.length <= 0) {
        return demo;
      }

      let provinces = [];
      let province_city = {};

      // 遍历
      provinces_offline_jobs.forEach((province) => {
        const p_citys = provinces_city_offline_jobs[province]
        let havs_city = false
        if (util.isArrayFn(p_citys)) {
          p_citys.forEach((city) => {
            if (citys.includes(city)) {
              if (havs_city === false && !provinces.includes(province)) {
                provinces.push(province)
              }
              if (province_city[province] && util.isArrayFn(province_city[province])) {
                province_city[province].push(city)
              } else {
                province_city[province] = [city]
              }
              havs_city = true
            }
          })
        }
      })

      // 
      for (var key in citys_obj) {
        const key_provice = citys_obj[key];
        if (province_city[key_provice] || provinces.includes(key_provice)) {
          continue;
        } else if (provinces_city_offline_jobs[key_provice]) {
          provinces.push(key_provice);
          province_city[key_provice] = provinces_city_offline_jobs[key_provice]
        }
      }

      return {
        provinces: provinces,
        province_city: province_city
      }
    }
/**
 * @param {Object} interviewer_id
 * @param {Object} video_erp_register_id
 * @param {Object} time 视频双选会创建时间
 */
util.getReceiverId = function(interviewer_id,video_erp_register_id,time){
	if(time < util.newVersionTime){
		return video_erp_register_id
	}else{
		return interviewer_id;
	}
}

export default util



// WEBPACK FOOTER //
// ./src/common/libs/util.js